module.exports = __webpack_public_path__ + "static/media/account-cash-outline.0360061f.svg";